import { Page } from "pages/Page";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const title = "Log in required";
const description = "You must be logged in to access this page";

export const AuthRequiredPage = (props: { redirect: string }) => {
    const { redirect } = props;

    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);

    const redirectUrl = redirect.includes("?")
        ? `${redirect}&returnUrl=${returnUrl}`
        : `${redirect}?returnUrl=${returnUrl}`;

    const history = useHistory();

    useEffect(() => {
        history.push(redirectUrl);
    }, [history, redirectUrl]);

    return <Page canonical={window.location.href} description={description} title={title}></Page>;
};
